/**
 * Truncates any string provided
 * @param {Array} tree Tree to search
 * @param {String} value Value to search for  length before truncating. Default: 0
 * @param {String} key property that contains key
 * @param {String} childProperty property that contains children
 * @param {Boolean} reverse Search from behind first
 * @returns first matched item
 */
export default function search(
  tree,
  value,
  key = 'id',
  childProperty = 'children',
  reverse = false
) {
  let stack = []

  if (tree.length > 1) {
    const firstItem = {}

    firstItem.title = 'global'
    firstItem[key] = 'global-node'
    firstItem[childProperty] = []
    for (var x = 0; x < tree.length; x++) {
      firstItem[childProperty].push(tree[x])
    }
    stack = [firstItem]
  } else {
    stack = [tree[0]]
  }
  while (stack.length) {
    const node = stack[reverse ? 'pop' : 'shift']()
    if (node[key] === value) return node
    node[childProperty] && stack.push(...node[childProperty])
  }
  return null
}
